import _ from 'lodash'
import {useEffect, useRef, useState} from 'react'
import {NullAsDefault} from 'views/Shared'

const useExamTimer = ({
  callback = NullAsDefault,
  trigger = false,
  initialHours = 0,
  initialMinutes = 0,
  initialSeconds = 0,
  autoStart = true,
}) => {
  const [stop, setStop] = useState()
  const [minutes, setMinutes] = useState(initialMinutes)
  const [seconds, setSeconds] = useState(initialSeconds)
  const [hours, setHours] = useState(initialHours)

  const mInterval = useRef(null)

  useEffect(() => {
    if (autoStart) {
      mInterval.current = setInterval(() => {
        if (stop) return
        if (seconds > 0) {
          setSeconds((seconds) => seconds - 1)
        }
        if (seconds === 0) {
          if (minutes === 0) {
            if (hours === 0) {
              clearInterval(mInterval.current)
              mInterval.current = null
              setStop(true)
            } else {
              setSeconds(59)
              setMinutes(59)
              setHours((hours) => hours - 1)
            }
          } else {
            setSeconds(59)
            setMinutes((minutes) => minutes - 1)
          }
        }
      }, 1000)
    }
    return () => {
      clearInterval(mInterval.current)
      mInterval.current = null
    }
  })

  useEffect(() => {
    if (!!trigger) {
      clearInterval(mInterval.current)
      mInterval.current = null
      setStop(true)
    }
  }, [trigger])

  useEffect(() => {
    const total = _.defaultTo(Number(hours + minutes + seconds))
    if (autoStart && total === 0) {
      callback()
    }
  }, [autoStart, hours, minutes, seconds])

  return {
    hours,
    minutes,
    seconds,
    trigger,
  }
}

export default useExamTimer
